import React, { useState, useEffect } from 'react';
import axios from 'axios';

const VideoDelete = () => {
  const [videos, setVideos] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  // Fetch all videos once when the component mounts
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_REQUESTING_API}/api/videos`);
        setVideos(response.data);
      } catch (error) {
        console.error('Error fetching videos:', error);
      }
    };

    fetchVideos();
  }, []);

  // Function to filter videos based on search term
  const filteredVideos = videos.filter(video =>
    video.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    video.videoUrl.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Function to delete a video
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this video?');
    if (!confirmDelete) return;

    try {
      const response = await axios.delete(`${process.env.REACT_APP_REQUESTING_API}/api/videos/${id}`);
      console.log('Delete response:', response);
      setVideos(videos.filter(video => video._id !== id)); // Remove video from state
      alert('Video successfully deleted');
    } catch (error) {
      console.error('Failed to delete the video:', error);
      alert('Failed to delete the video');
    }
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Search and Delete Videos</h1>

      {/* Live Search Bar */}
      <div className="mb-4  ">
        <input
          type="text"
          placeholder="Search by title or video URL"
          className=" p-2 w-[40%] border-2 rounded-full"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)} // Update the search term live
        />
      </div>

      {/* Show "No videos found" if no results match the search */}
      {searchTerm && filteredVideos.length === 0 && <p>No videos found</p>}

      {/* Only show videos if search term is not empty */}
      {searchTerm && (
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filteredVideos.map((video) => (
            <div key={video._id} className="border rounded-lg p-4 shadow-lg">
              <img
                src={video.thumbnailUrl}
                alt={video.title}
                className="w-full h-48 object-cover mb-4"
              />
              <h3 className="text-lg font-semibold">{video.title}</h3>
              <a
                href={video.videoUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500"
              >
                Watch Video
              </a>
              <button
                onClick={() => handleDelete(video._id)}
                className="mt-4 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded w-full"
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VideoDelete;
